<template>
  <DropdownMenu :show-chevron="false">
    <div class="notifications__icon-holder">
      <font-awesome-icon
        class="text-text-brand"
        icon="fa-regular fa-bell"
        size="lg"
      />
      <span
        class="notifications__count"
        v-if="notificationsStore.getUnseenCount() > 0"
        >{{ notificationsStore.getUnseenCount() }}</span
      >
    </div>

    <template v-if="notifications.length > 0" #dropdown>
      <MenuItem
        class="py-xs"
        v-for="(notification, index) in notifications"
        :key="index"
      >
        <RouterLink
          class="no-underline"
          :to="notification.link"
          target="_blank"
        >
          <div
            class="items-startleading-0 flex flex-col gap-none text-text-primary"
          >
            <small class="leading-0">{{ notification.type }}</small
            ><span class="leading-0">{{ notification.title }}</span>
          </div>
        </RouterLink></MenuItem
      >
      <MenuItem v-on:click="markAllAsSeen()"
        ><FontAwesomeIcon
          class="text-text-brand"
          icon="fa-regular fa-square-xmark"
          size="lg"
        /><span>Rensa alla</span></MenuItem
      >
    </template>

    <template v-else #dropdown>
      <p class="px-sm py-md text-center">Inga olästa notifikationer</p>
    </template>
  </DropdownMenu>
</template>
<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBell, faSquareXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed, onMounted } from "vue";

import DropdownMenu from "@/components/ui/DropdownMenu.vue";
import MenuItem from "@/components/ui/MenuItem.vue";

import { useNotificationsStore } from "./store";

const notificationsStore = useNotificationsStore();

onMounted(() => {
  notificationsStore.fetchNotifications();
});

const notifications = computed(() =>
  notificationsStore.getUnseenNotifications(),
);

const markAllAsSeen = () => {
  notificationsStore.markAllAsSeen();
};

library.add(faBell, faSquareXmark);
</script>
<style scoped>
.notifications__count {
  display: block;
  position: absolute;
  top: 1px;
  right: -2px;
  border: 1px solid #fff;
  border-radius: 16px;
  background-color: var(--feedback-alert-darker);
  padding: 0 5px;
  min-width: 18px;
  min-height: 16px;
  color: #fff;
  font-weight: bold;
  font-size: 10px;
  line-height: 16px;
  user-select: none;
  text-align: center;
}

.notifications_dropdown {
  position: absolute;
  top: calc(100% + 20px);
  right: calc(-140px + 30px);
  z-index: 999;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid var(--grey-lightened-50);
  border-radius: 4px;
  background-color: #fff;
  width: 280px;
  min-height: 10px;
}
</style>
